import React, { useState } from 'react';
import { FileTextIcon, UsersIcon, DollarSignIcon, TruckIcon, FileCheckIcon, PackageIcon } from 'lucide-react';
import { QuoteStepHeader } from '../shared/QuoteStepHeader';
import { QuoteStepNavigation } from '../shared/QuoteStepNavigation';
import { PartsSelectionStep } from './PartsSelectionStep';
import { CustomerInfoStep } from '../shared/CustomerInfoStep';
import { QuoteDetailsStep } from './QuoteDetailsStep';
import { ShippingTermsStep } from '../shared/ShippingTermsStep';
import { QuoteReviewStep } from '../shared/QuoteReviewStep';
export function SparePartsQuoteFlow({
  initialData = null
}) {
  const [currentStep, setCurrentStep] = useState(0);
  const [quoteData, setQuoteData] = useState({
    parts: initialData?.parts || [],
    customerInfo: initialData?.customerInfo || {},
    quoteDetails: initialData?.quoteDetails || {},
    shipping: initialData?.shipping || {},
    // Preservar otros datos importantes si estamos editando
    ...(initialData && {
      id: initialData.id,
      quoteNumber: initialData.quoteNumber,
      date: initialData.date,
      status: initialData.status,
      expiryDate: initialData.expiryDate,
      quotedBy: initialData.quotedBy,
      type: 'Spare Parts'
    })
  });
  const steps = [{
    label: 'Select Parts',
    icon: <PackageIcon size={16} data-id="element-5317" />
  }, {
    label: 'Quote Details',
    icon: <FileTextIcon size={16} data-id="element-5318" />
  }, {
    label: 'Customer Info',
    icon: <UsersIcon size={16} data-id="element-5319" />
  }, {
    label: 'Shipping & Terms',
    icon: <TruckIcon size={16} data-id="element-5320" />
  }, {
    label: 'Review',
    icon: <FileCheckIcon size={16} data-id="element-5321" />
  }];
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      // Submit quote
      console.log('Submit quote', quoteData);
    }
  };
  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  const handleSave = () => {
    console.log('Save draft', quoteData);
  };
  const updateQuoteData = (section, data) => {
    setQuoteData({
      ...quoteData,
      [section]: data
    });
  };
  return <div className="bg-slate-800/30 rounded-xl border border-blue-800/30 p-6" data-id="element-5322">
      <QuoteStepHeader steps={steps} currentStep={currentStep} onChangeStep={setCurrentStep} data-id="element-5323" />
      <div className="mt-8" data-id="element-5324">
        {currentStep === 0 && <PartsSelectionStep initialData={quoteData.parts} onUpdate={data => updateQuoteData('parts', data)} data-id="element-5325" />}
        {currentStep === 1 && <QuoteDetailsStep initialData={quoteData.quoteDetails} onUpdate={data => updateQuoteData('quoteDetails', data)} data-id="element-5326" />}
        {currentStep === 2 && <CustomerInfoStep initialData={quoteData.customerInfo} onUpdate={data => updateQuoteData('customerInfo', data)} data-id="element-5327" />}
        {currentStep === 3 && <ShippingTermsStep initialData={quoteData.shipping} onUpdate={data => updateQuoteData('shipping', data)} data-id="element-5328" />}
        {currentStep === 4 && <QuoteReviewStep quoteData={quoteData} quoteType="Spare Parts" data-id="element-5329" />}
      </div>
      <QuoteStepNavigation currentStep={currentStep} totalSteps={steps.length} onNext={handleNext} onBack={handleBack} onSave={handleSave} isFinalStep={currentStep === steps.length - 1} data-id="element-5330" />
    </div>;
}